import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"controller-button-square, view, panel"} maskId="square-filled-radius-0-stroke-1-IconControllerButtonSquare"><path d="M16 16H8V8H16V16Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM7 17H17V7H7V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconControllerButtonSquare;
